// src/pages/HomePage.js
import React from 'react';
import Nav from '../components/nav/Nav';
import Header from '../components/header/Header';
import Main from '../components/main/Main';
import Reclubbing from '../components/re-clubbing/Reclubbing';
import Footer from '../components/footer/Footer';
import './HomePage.css';
import heroVideo from '../assets/video header 2.mp4'; // <-- 1. Import your video

// The currentImage prop is now gone
function HomePage() {
  return (
    <div className='home-page'>
      {/* Top section will now be a video background container */}
      <div
        className='top-section'
        // The old 'style' prop is removed
      >
        {/* 2. Add the video tag HERE */}
        <video
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
          className='top-section-video'
        />

        {/* 3. Nav and Header will now render ON TOP of the video */}
        <Nav />
        <Header />
      </div>
      <Main />
      <Reclubbing />
      <Footer />
    </div>
  );
}

export default HomePage;
